import { makeAutoObservable } from "mobx";
import Subjects from "../../models/subjects";
import DictionariesService from "../../services/dictionaries";
import { SelectorItem } from "../common/selector-store";

export interface DepsDictionary {
    id: string;
    name: string;
    items: SelectorItem[];
}

class SelectorValues {

    items: SelectorItem[];
    selectedItem: string;

    constructor() {
        this.items = [];
        this.selectedItem = "";

        makeAutoObservable(this);
    }

    selectItem(value: string): void {
        this.selectedItem = value;
    }

    setValues(values: SelectorItem[]): void {
        this.items = values;
        if (values.length === 1) {
            this.selectedItem = values[0].id;
        } else {
            this.selectedItem = "";
        }
    }

    reset(): void {
        this.selectedItem = "";
    }

    selectFirst() {
        this.selectedItem = this.items[0].id;
    }

    get selectedItemAsNumber(): number | null {
        return this.selectedItem === "" ? null : Number(this.selectedItem);
    }

    get selectedItemValue(): string {
        if (this.selectedItem === null) return '';

        return this.items
            .filter(item => this.selectedItem === item.id)
            .map(item => item.name)[0];
    }
}

export default class NumberInKimWithThemeStore {

    dictionariesService: DictionariesService;
    numberWithThemesMap: DepsDictionary[];

    numberInKim: SelectorValues;
    theme: SelectorValues;

    subject: Subjects;

    constructor(subject: Subjects) {

        this.subject = subject;
        this.numberInKim = new SelectorValues();
        this.theme = new SelectorValues();
        this.numberWithThemesMap = [];
        this.dictionariesService = new DictionariesService();

        makeAutoObservable(this);
    }

    loadDictionaries = async () => {
        return this.dictionariesService.getNumbersWithThemes(
            this.subject,
            (data) => {
                this.numberWithThemesMap = data;
                this.numberInKim.setValues(
                    this.numberWithThemesMap.map((v) => { return { id: v.id, name: v.name } as SelectorItem })
                );
            });
    }

    isNotLoaded() {
        return this.numberWithThemesMap.length === 0;
    }

    selectNumberInKim(value: string) {
        this.numberInKim.selectItem(value);
        this.theme.setValues(
            this.numberWithThemesMap.filter(v => v.id === value).map((d) => d.items)[0]
        );
        this.theme.selectFirst();
    }

    reset(): void {
        this.numberInKim.selectItem(this.numberWithThemesMap[0]?.id);
        this.theme.setValues(this.numberWithThemesMap[0]?.items);
    }
}